import React from "react";
import { Link } from "react-router-dom";
import ASection1 from "./ASection1/ASection1";
import ASection2 from "./ASection2/ASection2";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";

const aboutHighlights = [
  {
    title: "Mission & Vision",
    description: "Discover the purpose, values, and future direction that guide Kindness Unlimited.",
    to: "/missionvision",
    badge: "Purpose",
  },
  {
    title: "Our Story",
    description: "Follow the journey of KU from its beginnings to its growth as a global kindness movement.",
    to: "/ourstory",
    badge: "Journey",
  },
  {
    title: "Our Team",
    description: "Meet the trustees, mentors, and volunteers bringing this mission to life in communities.",
    to: "/ourteam",
    badge: "People",
  },
];

const About = () => (
  <PageLayout>
    <PageHero title="What We Do" eyebrow="About Kindness Unlimited" subtitle="Balancing self-interest with the common good — practically, sustainably, and with heart." light />

    <section className="ku-section bg-slate-50 py-16">
      <div className="ku-container max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-10">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-ku-violet mb-3">About Us</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-ku-royal">
            Everything that defines who we are
          </h2>
          <p className="mt-4 text-lg text-gray-600 leading-relaxed">
            Kindness Unlimited is built around purpose, people, and a long-term vision for a kinder society. Explore the heart of our work below.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {aboutHighlights.map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className="group flex h-full flex-col rounded-3xl border border-purple-100 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <span className="mb-4 inline-flex w-fit rounded-full bg-purple-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-ku-violet">
                {item.badge}
              </span>
              <h3 className="font-display text-xl font-bold text-ku-royal">{item.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-7 text-gray-600">{item.description}</p>
              <span className="mt-5 inline-flex items-center text-sm font-semibold text-ku-violet transition-transform group-hover:translate-x-1">
                Explore
                <span className="ml-2">→</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>

    <ASection1 />
    <ASection2 />
  </PageLayout>
);

export default About;
